import { render, staticRenderFns } from "./PropertyInformation.vue?vue&type=template&id=5b2a4f5b"
import script from "./PropertyInformation.vue?vue&type=script&lang=js"
export * from "./PropertyInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports